module.exports = __webpack_public_path__ + "static/media/Checkbox__checkmark.758b2303.svg";